import apiReq from '../commontools/api.js'
export function GetOrderPersonByOrder(OrderID) {

	var url='/OrderPerson/GetOrderPersonByOrder/'+OrderID;
	return apiReq.get(url)
}
export function DawnSingle(PID) {

	var url='/OrderPerson/DawnSingle/'+PID;
	return apiReq.defaults.baseURL+url;
}
export function ApproveOrderPerson(info) {

	var url='/OrderPerson/ApproveOrderPerson';
	var p={
		data:info
	}
	return apiReq.post(url,p)
}
export function DelPFile(PID) {
	var url = '/OrderPerson/DelPFile/' + PID;
	return apiReq.get(url)
}
export function UploadOrderPerson(p, info) {

	var url = '/OrderPerson/UploadOrderPerson/'+JSON.stringify(info);
	return apiReq.post(url, p);
}


export default{
	GetOrderPersonByOrder,
	ApproveOrderPerson,
	DawnSingle,
	DelPFile,
	UploadOrderPerson
}